import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'tab-page',
    imports: [CommonModule],
    templateUrl: './tab-page.component.html',
    styleUrls: ['./tab-page.component.scss']
})
export class TabPageComponent {
    @Input()
    title: string = '';

    @Input()
    icon: string = '';

    @Input()
    active: boolean = false;
};